<div class="provider-card">
    <div class="provider-card-left">

        <div class="provider-card-header d-flex justify-content-between align-items-center flex-wrap">
            <!-- Left side: Avatar + Name + Speciality -->
            <div class="d-flex align-items-center gap-3" style="flex-grow: 1;">
                <div class="patient-avatar">
                    <ng-container *ngIf="provider.imgLogoUrl; else defaultIcon">
                        <img [src]="provider.imgLogoUrl" alt="{{ provider.name }}" />
                    </ng-container>

                    <ng-template #defaultIcon>
                        <span class="icon-btn" style="padding: 12px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256">
                                <path fill="#757474"
                                    d="M248 212h-12v-84a12 12 0 0 0-12-12h-60V48a12 12 0 0 0-12-12H56a12 12 0 0 0-12 12v164H32a4 4 0 0 0 0 8h216a4 4 0 0 0 0-8m-24-88a4 4 0 0 1 4 4v84h-64v-88ZM52 48a4 4 0 0 1 4-4h96a4 4 0 0 1 4 4v164h-24v-52a4 4 0 0 0-4-4H80a4 4 0 0 0-4 4v52H52Zm72 164H84v-48h40ZM76 96a4 4 0 0 1 4-4h20V72a4 4 0 0 1 8 0v20h20a4 4 0 0 1 0 8h-20v20a4 4 0 0 1-8 0v-20H80a4 4 0 0 1-4-4"
                                    stroke-width="1.5" stroke="#757474" />
                            </svg>
                            <p>hi userrrr</p>
                        </span>

                    </ng-template>
                </div>


                <div class="d-flex flex-column gap-1">
                    <div class="provider-name">{{ provider.name }}</div>
                    <div *ngIf="provider.speciality">
                        <span class="gray-text fs-11">Speciality : </span>
                        <span class="fs-11">{{ provider.speciality }}</span>
                    </div>
                </div>
            </div>

            <!-- Right side: Status + Actions -->
            <div class="d-flex align-items-center gap-3 ms-auto flex-wrap">
                <div class="provider-action">
                    <div class="chips-container">
                        <span class="chip active-chip" *ngIf="provider.isactive">Active</span>
                        <span class="chip deactive-chip" *ngIf="!provider.isactive">Deactived</span>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="action-buttons d-flex align-items-center gap-2" *ngIf="!actionHidden">
                    @if (!provider.isactive) {
                    <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
                        (click)="onStatusUpdate(true); $event.stopPropagation()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                            <path fill="#53e643" fill-rule="evenodd"
                                d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                                clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                        </svg>
                    </span>
                    } @else {
                    <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
                        (click)="onStatusUpdate(false); $event.stopPropagation()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                            <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                                stroke-width="0.1" stroke="#e84721" />
                        </svg>
                    </span>
                    }
                    <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
                        (click)="onEditprovider(); $event.stopPropagation()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                            <path fill="#66AEE0" fill-rule="evenodd"
                                d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                                clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                            <path fill="#66AEE0"
                                d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                                stroke-width="0.1" stroke="#66AEE0" />
                        </svg>
                    </span>
                </div>
            </div>
        </div>


        <div class="provider-meta-horizontal mt-4">

            <!-- <div>
              <span class="smallIcon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                  <path fill="#66AEE0"
                    d="M19.965 8.521Q20 8.26 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8q0 .26.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A4 4 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16q0-.26-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479m-9.01 7.895l-3.667-3.714l1.424-1.404l2.257 2.286l4.327-4.294l1.408 1.42z" />
                </svg>
              </span>
              {{ provider.boardCertified ? 'Board Certified' : 'Not Board Certified' }}
            </div> -->

            <div *ngIf="provider.experience">
                <span class="smallIcon">
                    <!-- Experience Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="#66AEE0"
                            d="M4 19V8h16v3.29c.72.22 1.4.54 2 .97V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h7.68c-.3-.62-.5-1.29-.6-2zm6-15h4v2h-4z" />
                        <path fill="#66AEE0"
                            d="M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85z" />
                    </svg>
                </span>
                {{ provider.experience }} Years
            </div>

            <div>
                <span class="smallIcon">
                    <!-- Location Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 48 48">
                        <path fill="#66AEE0"
                            d="M39.015 28.98A16.9 16.9 0 0 0 41 21c0-9.389-7.611-17-17-17S7 11.611 7 21a16.92 16.92 0 0 0 4 10.955l.02.025l.018.02H11l10.088 10.71a4 4 0 0 0 5.823 0L37 32h-.038l.016-.019l.002-.002q.108-.129.215-.26a17 17 0 0 0 1.82-2.74m-15.01-1.48a6 6 0 1 1 0-12a6 6 0 0 1 0 12" />
                    </svg>
                </span>
                {{ provider.location }}
            </div>

            <div *ngIf="provider.licenseNumber">
                <span class="smallIcon">
                    <!-- Location Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 2048 1536">
                        <path fill="#66AEE0"
                            d="M896 1084q0 55-31.5 93.5T789 1216H363q-44 0-75.5-38.5T256 1084q0-54 7.5-100.5t24.5-90t51-68.5t81-25q64 64 156 64t156-64q47 0 81 25t51 68.5t24.5 90T896 1084M768 640q0 80-56 136t-136 56t-136-56t-56-136t56-136t136-56t136 56t56 136m1024 416v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23m-384-256v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23m384 0v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23m0-256v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23m128 832V256H128v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5m128-1216v1216q0 66-47 113t-113 47H160q-66 0-113-47T0 1376V160Q0 94 47 47T160 0h1728q66 0 113 47t47 113"
                            stroke-width="38.5" stroke="#66AEE0" />
                    </svg>
                </span>
                {{ provider.licenseNumber }}
            </div>

        </div>

        <div class="provider-meta-horizontal d-flex align-items-center justify-content-between mt-2">
            <div class="contact-info d-flex gap-3">
                <div class="contactBox d-flex align-items-center gap-1">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="#66AEE0"
                                d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
                        </svg>
                    </span>
                    {{ provider.contactNumber }}
                </div>

                <div class="contactBox d-flex align-items-center gap-1">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="#66AEE0"
                                d="M5 5h13a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 1c-.5 0-.94.17-1.28.47l7.78 5.03l7.78-5.03C18.94 6.17 18.5 6 18 6zm6.5 6.71L3.13 7.28C3.05 7.5 3 7.75 3 8v9a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V8c0-.25-.05-.5-.13-.72z" />
                        </svg>
                    </span>
                    {{ provider.email }}
                    <span class="copy-icon" (click)="copyToClipboard(provider.email)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="#1976d2"
                                d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                        </svg>
                    </span>

                    <span *ngIf="copiedEmail === provider.email" class="copied-text"
                        style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                        Copied!
                    </span>
                </div>

                <div class="contactBox d-flex align-items-center gap-1">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                            <path fill="#66AEE0"
                                d="M12.02 20q-1.664 0-3.119-.626T6.359 17.66t-1.714-2.542T4.02 12t.626-3.118T6.36 6.34T8.9 4.626T12.019 4q1.723 0 3.282.712q1.559.711 2.718 1.984V4.308h1v4.154h-4.153v-1h2.48q-1.044-1.15-2.41-1.806Q13.572 5 12.02 5Q9.094 5 7.057 7.038T5.019 12t2.038 4.963T12.019 19q2.625 0 4.569-1.71t2.35-4.29h1.012q-.356 3.021-2.62 5.01Q15.066 20 12.02 20m3.146-4.146l-3.647-3.646V7h1v4.792l3.354 3.354z" />
                        </svg>
                    </span>
                    {{ provider.lastupdatedon | date : 'dd-MM-yyyy HH:mm' }}
                </div>

            </div>
        </div>

    </div>
</div>